import axiosInstance from '../helpers/axios';
import { types } from '../types/types';
import { getToken } from './auth';

// Add individual areas
export const setIndividualAreas = (data) => ({
	type: types.setIndividualAreas,
	payload: data,
});

// Reset individual areas
export const cleanIndividualAreas = (data) => ({
	type: types.cleanIndividualAreas,
	payload: data,
});

// Get individual areas
export const getIndividualAreas = async (idBias) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/individual-area/?bias=${idBias}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Get individual area's info
export const getIndividualAreaInfo = async (idIndividualArea) => {
	const token = getToken();
	return await axiosInstance({
		method: 'get',
		url: `/api/bias/individual-area/${idIndividualArea}`,
		headers: { Authorization: 'Bearer ' + token },
	});
};

// Register individual area
export const registerIndividualArea = async (data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'post',
		url: '/api/bias/individual-area/',
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};

// Update individual area
export const updateIndividualArea = async (idIndividualArea, data) => {
	const token = getToken();
	return await axiosInstance({
		method: 'put',
		url: `/api/bias/individual-area/${idIndividualArea}`,
		headers: { Authorization: 'Bearer ' + token },
		data,
	});
};
